import { render, staticRenderFns } from "./modalAddTenantTournament.vue?vue&type=template&id=d3efbc28&"
import script from "./modalAddTenantTournament.vue?vue&type=script&lang=js&"
export * from "./modalAddTenantTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports